import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBNNbAtwKCdwH3HTYappfICYp-z16ugIz0",
  authDomain: "afiliadosmarket.firebaseapp.com",
  projectId: "afiliadosmarket",
  storageBucket: "afiliadosmarket.firebasestorage.app",
  messagingSenderId: "348355162612",
  appId: "1:348355162612:web:7496071ca95f1a727a09a1",
  measurementId: "G-85K8C66YTR"
};

const app = initializeApp(firebaseConfig);

export default app;
